<template>
  <div class="bg-gray-200 dark:bg-gray-900 p-2">
    <!-- Modals -->
    <add-modal @refresh="getAll()" />
    <edit-modal @refresh="getAll()" :rowId="selectedOrder.id" />
    <product-add-modal
      :defaultName="productName"
      @refresh="getAll(true, true, true)"
    />

    <vehicle-modal :detail="selectedOrder" :key="`vehicle-modal-${selectedOrder.orderNo}-${selectedOrder.vehicle?.id || 'none'}`" />
    <pirate-driver-detail-modal :detail="selectedOrder" />
    <reallocation-needed-modal
      :show="showReallocationModal"
      :order="selectedOrder"
      :reallocation-message="reallocationMessage"
      :planned-orders="activeOrdersWithVehicles"
      @close="showReallocationModal = false"
      @reallocate="handleReallocateVehicles"
    />
    <confirmation-modal
      :show="showConfirmationModal"
      :order="confirmationOrder"
      @close="showConfirmationModal = false"
      @confirm="confirmRemoveOrder"
    />

    <ConfirmationSaveModal
      :show="showSaveConfirmation"
      :orders="selectedList"
      :orderCount="selectedList.length"
      @confirm="handleSaveOrders"
      @close="showSaveConfirmation = false"
      :loading="saveLoad"
    />
    <pirate-driver-modal :item="pirateDriverplanProp" @refresh="getAll()" />

    <add-customer-modal
      @formSubmitted="handleCustomerFormSubmitted"
      :customerName="selectedOrder.customer"
    />

    <product-edit-modal :detail="defaultProductDataProp" />

    <equipment-plan-modal
      :order="selectedOrder"
      :vehicles="getVehiclesWithInventory"
      @plan-with-equipment="handleEquipmentPlan"
    />

    <!-- Context Menu -->
    <vue-context ref="menu" v-if="activeState != 2">
      <li><a href="#" @click.prevent="customPlan(1)">Kiralık Araç Öner</a></li>
      <li><a href="#" @click.prevent="customPlan(2)">Özmal Araç Öner</a></li>
      <li><a href="#" @click.prevent="customPlan(4)">Korsan ile planla</a></li>
      <li><a href="#" @click.prevent="planWithEquipment">Ekipman ile Planla</a></li>
    </vue-context>

    <div class="p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
      <div
        :class="
          isFullScreen && 'fixed top-0 w-full z-50 left-0 h-full bg-white'
        "
      >
        <!-- Main Content -->
        <div class="w-full mt-2">
          <!-- Header with buttons and filters -->

          <OrderHeader
            :isFullScreen="isFullScreen"
            :planningLoad="planningLoad"
            :saveLoad="saveLoad"
            :orderCount="orderCounts"
            :activeState="activeState"
            :selectedCount="selectedList.length"
            :search="search"
            :loading="loading"
            @save-orders="saveOrders"
            @change-tab="changeTab"
            @search="(val) => (search = val)"
            @refresh="() => getAll(true, true)"
            @clear-orders="() => clearOrders()"
          />

          <!-- Orders Table -->
          <OrdersTable
            :orderCount="orderCounts"
            :isFullScreen="isFullScreen"
            :activeState="activeState"
            :orders="displayedOrders"
            :planningLoad="planningLoad"
            :loading="loading"
            :products="products"
            :vehicleList="getFilterVehicles"
            :customers="customers"
            @select-order="handleOrderSelect"
            @view-order="viewOrderDetail"
            @remove-order="removeFromPlanned"
            @change-vehicle="handleChangeVehicle"
            @change-driver="changeDriver"
            @open-context="openContextMenu"
            @handle-personel-change="
              (driver, item) => handlePersonelChange(driver, item)
            "
            @distance-calculated="handleDistanceCalculated"
          />

          <!-- Pagination -->
          <div
            :class="
              !isFullScreen
                ? 'flex justify-between items-center'
                : 'absolute bottom-0 w-full bg-white flex justify-between items-center pr-2'
            "
          >
            <PaginationComponent
              v-if="!loading"
              :pageCount="pageCount"
              v-model="currentPage"
              :totalRowCount="
                activeState == 2 ? selectedList.length : orderList.length
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import components
import OrderHeader from "./components/OrderHeader.vue";
import OrdersTable from "./components/OrdersTable.vue";
import PaginationComponent from "@/components/general/pagination.vue";
import AddModal from "./modals/add.modal.vue";
import EditModal from "./modals/edit.modal.vue";

import VehicleModal from "@/components/modals/vehicle.detail.modal/index.vue";
import pirateDriverDetailModal from "@/components/modals/vehicle.detail.modal/pirateDriverModal.vue";

import ProductAddModal from "../../control-panel/products/components/add.modal.vue";
import ProductEditModal from "../../control-panel/products/components/edit.modal.vue";
import AddCustomerModal from "../../control-panel/customers/components/add.modal.vue";

import ConfirmationModal from "./modals/ConfirmationModal.vue";
import PirateDriverModal from "./modals/piratedriver.modal.vue";
import ConfirmationSaveModal from "./modals/orderSaveConfirmation.vue";
import ReallocationNeededModal from "./modals/reallocation.needed.modal.vue";
import EquipmentPlanModal from "./modals/equipmentPlan.modal.vue";

import VueContext from "vue-context";

// Import services & tools
import { fetchOrders, saveOrdersWithVehicles } from "./tools/orderService";
import { getLocationAll, getCustomers, getProducts } from "@/utils/detailData";
import {processOrderSelection} from "./tools/orderTools/index";
import { ordersRules } from "./rules";
import { changeVehicle } from "./tools/orderTools/changeVehicle";
import { reallocateVehicles } from "./tools/orderTools/reallocateVehicles";
export default {
  name: "orders-module",
  components: {
    OrderHeader,
    OrdersTable,
    PaginationComponent,
    AddModal,
    EditModal,
    ProductAddModal,
    VehicleModal,
    pirateDriverDetailModal,
    VueContext,
    ConfirmationModal,
    PirateDriverModal,
    ProductEditModal,
    AddCustomerModal,
    ConfirmationSaveModal,
    ReallocationNeededModal,
    EquipmentPlanModal,
  },
  data() {
    return {
      planningLoad: false,
      saveLoad: false,
      currentPage: 0,
      pageCount: 1,
      totalCount: 0,
      isFullScreen: false,
      activeState: 1,
      orderList: [],
      selectedList: [],
      errorCount: 0,
      successCount: 0,
      vehicleList: [],
      inProgress: false,
      selectedVehicles: [],
      products: [],
      customers: [],
      loading: false,
      search: "",
      productName: "",
      tripTonnage: 26,
      selectedOrder: { id: "", plaque: "", vehicleId: "" },
      selectedContextItem: null,
      currentHaveType: null,
      showConfirmationModal: false,
      confirmationOrder: null,
      defaultProductDataProp: null, // Eklendi
      pirateDriverplanProp: null, // Eklendi

      showSaveConfirmation: false,

      showReallocationModal: false,
      reallocationMessage: "",
      maxDistance: 300, // varsayılan mesafe sınırı
      activeOrdersWithVehicles: [], // aktif siparişler ve araçları
      _safetyTimeout: null, // handleOrderSelect safety timeout referansı
      _searchDebounce: null, // search debounce timer
      _getAllRequestId: 0, // stale request cancellation
    };
  },
  computed: {
    orderCounts() {
      return {
        unplanned: this.successCount - this.selectedList.length,
        planned: this.selectedList.length,
        error: this.errorCount,
      };
    },
    getFilterVehicles() {
      // Planlananlar tablosundaki araçlara planlanmış orderlerin no larını ekleme
      // NOT: Orijinal kod computed içinde veri mutasyonu yapıyordu (push) — reactivity döngüsüne yol açıyordu
      const vehicleOrderMap = {};
      this.selectedList?.forEach((item) => {
        if (item.vehicleName) {
          if (!vehicleOrderMap[item.vehicleName]) vehicleOrderMap[item.vehicleName] = [];
          if (!vehicleOrderMap[item.vehicleName].includes(item.orderNo))
            vehicleOrderMap[item.vehicleName].push(item.orderNo);
        }
      });

      return this.vehicleList.map((item) => {
        const plannedOrderNos = vehicleOrderMap[item.plate] || [];
        return {
          ...item,
          name: item.vehicle,
          isRent: item?.haveType,
          orderNos: [...(item.orderNos || []), ...plannedOrderNos],
        };
      });
    },
    displayedOrders() {
      const activeState = this.activeState;
      const searchTerm = this.search.toLowerCase().trim();

      if (activeState === 2) {
        if (!searchTerm) return this.selectedList;

        return this.selectedList.filter((order) => {
          const orderNo = order.orderNo.toString();
          if (orderNo.includes(searchTerm)) return true;

          return (
            order.customer.toLowerCase().includes(searchTerm) ||
            order.deliveredName.toLowerCase().includes(searchTerm) ||
            order.invoicedCompany.toLowerCase().includes(searchTerm) ||
            order.orderName.toLowerCase().includes(searchTerm) ||
            order.receivedName.toLowerCase().includes(searchTerm) ||
            order.tonnage.toString().includes(searchTerm) ||
            order.outpointAdress.toLowerCase().includes(searchTerm) ||
            order.productType.toLowerCase().includes(searchTerm)
          );
        });
      } else {
        const selectedOrderSet = new Set(
          this.selectedList.map((order) => parseInt(order.orderNo))
        );
        return this.orderList.filter(
          (order) => !selectedOrderSet.has(parseInt(order.orderNo))
        );
      }
    },
    getVehiclesWithInventory() {
      // Araçları envanter bilgileriyle birlikte döndür
      return this.vehicleList.map((vehicle) => {
        return {
          ...vehicle,
          name: vehicle.vehicle,
          isRent: vehicle?.haveType,
          // Araç envanteri (eğer varsa vehicleInventory alanından gelir)
          inventory: vehicle.inventory || vehicle.vehicleInventory || []
        };
      });
    },
  },
  methods: {
    saveOrders() {
      const isValid =
        ordersRules.shouldSelectAtLeastOneOrder(this.selectedList, this.$swal) &&
        ordersRules.shouldNotExceedMaxOrderLimit(this.selectedList, this.$swal) &&
        ordersRules.hasDriverInfoIssues(this.selectedList , this.$swal) ;
      if (!isValid) return;

      this.showSaveConfirmation = true;
    },
    handleCustomerFormSubmitted(data) {
      const targetItems = this.orderList.filter(
        (item) => item.customer === data.name
      );

      targetItems.forEach((targetItem) => {
        targetItem.customerId = data.customerId;
        if (targetItem.recomendation) {
          targetItem.recomendation.customerPriority = data.priority;
        }
      });
    },
    handlePersonelChange(val, item) {
      const targetItem = this.selectedList.find(
        (sItem) => sItem.orderNo == item.orderNo
      );
      if (targetItem) {
        targetItem.recomendation.srcEndTime = val.srcEndTime;
      }

      ordersRules.hasValidSRC5(item , val , this.products , this.$swal.fire);
    },
    handleDistanceCalculated({ vehicleId, orderNo, distance }) {
      // Manuel araç seçiminde hesaplanan gerçek mesafeyi güncelle
      // ÖNCELİKLE orderNo ile ara (daha güvenilir - araç değişse bile sipariş aynı)
      let targetOrder = this.selectedList.find(order => order.orderNo === orderNo);

      // Eğer orderNo ile bulunamazsa, vehicleId ile ara (fallback)
      if (!targetOrder) {
        targetOrder = this.selectedList.find(order => order.vehicle?.id === vehicleId);
      }

      if (targetOrder) {
        // Order objesinin mesafesini güncelle (Vue reactivity için $set kullan)
        this.$set(targetOrder, 'distance', distance);

        // Recomendation objesini oluştur/güncelle
        if (!targetOrder.recomendation) {
          this.$set(targetOrder, 'recomendation', {});
        }
        this.$set(targetOrder.recomendation, 'distancePriority', distance);

        // Araç objesini de güncelle
        if (targetOrder.vehicle) {
          this.$set(targetOrder.vehicle, 'distance', distance);
          this.$set(targetOrder.vehicle, '_osrmCalculated', true);

          if (!targetOrder.vehicle.recomendation) {
            this.$set(targetOrder.vehicle, 'recomendation', {});
          }
          this.$set(targetOrder.vehicle.recomendation, 'distancePriority', distance);
        }

        // $forceUpdate kaldırıldı — $set zaten reactivity sağlıyor
      }
    },
    customPlan(haveType) {
      if (this._safetyTimeout) clearTimeout(this._safetyTimeout);
      this.inProgress = false; // Önceki işlem takılmışsa kilidi aç
      this.currentHaveType = haveType;
      // Seçilen siparişin zaten planlanmış olup olmadığını kontrol et
      const isAlreadyPlanned = this.activeState === 2;

      // Eğer sipariş halihazırda planlanmışsa, önce onu kaldır
      if (isAlreadyPlanned) {
        // Mevcut planlanmış siparişi bul
        const existingOrderIndex = this.selectedList.findIndex(
          (item) =>
            parseInt(item.orderNo) ===
            parseInt(this.selectedContextItem.orderNo)
        );

        if (existingOrderIndex !== -1) {
          // Eski planlamayı kaldır
          this.selectedList.splice(existingOrderIndex, 1);
        }
      }

      // Korsan sürücü özel durumu
      if (haveType === 4) {
        // Korsan sürücü modalı için sipariş ata
        this.pirateDriverplanProp = this.selectedContextItem;

        // Root event listener ekle - korsan sürücü planı oluşturulduğunda çağrılacak
        this.$root.$once("add-pirate-driver-plan", (pirateDriverPlan) => {
          // Korsan sürücü planını selectedList'e ekle
          this.selectedList.push(pirateDriverPlan);
        });

        this.$modal.show("pirate-driver-modal");
        return;
      }

      // Diğer durumlarda normal akış devam etsin
      this.handleOrderSelect(this.selectedContextItem, haveType);
    },
    async getAll(
      showLoading = true,
      resetProducts = false,
      productCacheReset = false
    ) {
      // Stale request cancellation: her yeni çağrıda ID artır, eski yanıtları yoksay
      const requestId = ++this._getAllRequestId;
      this.loading = showLoading;
      try {
        // Only clear cache if explicitly requested - NOT when switching tabs
        if (resetProducts === true && this.search === "") {
          // Reset cache only when explicitly requested with search empty
          this.$store.commit("orders/clearPage");
        }

        // Try to get data from cache first
        const cachedOrders = this.$store.state.orders.List;

        if (cachedOrders.length > 0) {
          // Improved cache lookup - ensure we check for correct tab AND error state
          const currentFilter = this.$store.state.orders.activeFilter;
          const currentFilterKey = Array.isArray(currentFilter)
            ? currentFilter.map(f => f.name).sort().join(',')
            : '';

          const detail = cachedOrders.find((r) => {
            const cachedFilterKey = Array.isArray(r.filterCenter)
              ? r.filterCenter.map(f => f.name).sort().join(',')
              : '';
            return r.tab == this.activeState &&
              r.page == this.currentPage &&
              cachedFilterKey === currentFilterKey &&
              r.tabType == (this.activeState === 3 ? "error" : "normal");
          });

          if (detail) {
            // Use cached data if available
            const { data } = detail;
            this.pageCount = data.pageCount;
            this.totalCount = data.totalCount;
            this.errorCount = data.errorCount;
            this.successCount = data.successCount;
            this.orderList = data.orderList;
            // t-#674 çözümü 
            // this.loading = false;
            // return;
          }
        }

        // No cache hit - make API call
        const pageIndex = Math.max(0, this.currentPage - 1);

        // Important: Set the correct isErrorParam based on active tab
        let isErrorParam;
        if (this.activeState === 3) {
          isErrorParam = 0; // Sorunlu siparişler (Problematic orders)
        } else {
          isErrorParam = 1; // Planlanmayan siparişler (Unplanned orders)
        }

        const response = await fetchOrders(
          this.$store.state.userData.token,
          this.search,
          pageIndex,
          isErrorParam,
          this.$store.state.orders.activeFilter
        );

        // Stale request kontrolü: bu istek artık güncel değilse sonucu yoksay
        // NaN check eklendi - NaN !== NaN her zaman true döner
        if (typeof requestId === 'number' && !Number.isNaN(requestId) && requestId !== this._getAllRequestId) {
          return;
        }

        this.pageCount = response.pageCount;
        this.totalCount = response.totalCount;
        this.errorCount = response.errorCount;
        this.successCount = response.successCount;
        this.orderList = (response.detail || []).map((item) => ({
          ...item,
          isCustom: 2,
          driverTC: "",
        }));

        this.$store.commit("orders/setFilterList", response.filterList);

        // Store with better metadata to distinguish between tabs
        this.$store.commit("orders/addOrder", {
          tab: this.activeState,
          page: this.currentPage,
          filterCenter: this.$store.state.orders.activeFilter,
          tabType: this.activeState === 3 ? "error" : "normal", // Add tab type to distinguish
          data: {
            pageCount: this.pageCount,
            totalCount: this.totalCount,
            errorCount: this.errorCount,
            successCount: this.successCount,
            orderList: this.orderList,
          },
        });

        // Load products if requested
        if (resetProducts) {
          this.products = await getProducts(
            this.$store.state.userData.token,
            productCacheReset
          );
        }
      } catch (error) {
        // Stale request ise hata gösterme
        if (typeof requestId === 'number' && !Number.isNaN(requestId) && requestId !== this._getAllRequestId) {
          return;
        }
        this.errorBox(error.response);
      } finally {
        this.loading = false;
      }
    },
    async handleSaveOrders() {
      this.saveLoad = true;

      try {
        await saveOrdersWithVehicles(
          this.$store.state.userData.token,
          this.selectedList
        );

        this.showSaveConfirmation = false;
        this.saveLoad = false;
        this.selectedList = [];
        this.activeState = 1;
        this.$store.commit("orders/clearPage");
        await this.getAll();
      } catch (error) {
        this.$swal({
          title: "UYARI",
          text: error?.response?.data?.message || "İşlem gerçekleştirilemedi!",
          icon: "warning",
          confirmButtonText: "Tamam",
        });
      } finally {
        this.showSaveConfirmation = false;
        this.saveLoad = false;
      }
    },
    async handleOrderSelect(order, haveType = null) {
      if (this.inProgress) return;

      const isValid = ordersRules.shouldNotExceedMaxOrderLimit(
        this.selectedList,
        this.$swal
      );
      if (!isValid) return; 

      this.inProgress = true;
      this.currentHaveType = null;

      // Safety timeout: 30 saniye sonra kilit açılır (API çağrısı takılırsa)
      if (this._safetyTimeout) clearTimeout(this._safetyTimeout);
      const safetyTimeout = this._safetyTimeout = setTimeout(() => {
        if (this.inProgress) {
          console.warn("handleOrderSelect 30sn timeout - kilit açıldı");
          this.inProgress = false;
        }
      }, 30000);

      const isAlreadySelected = this.selectedList.find(
        (item) => parseInt(item.orderNo) === parseInt(order.orderNo)
      );

      if (isAlreadySelected) {
        this.removeFromPlanned(order);
        clearTimeout(safetyTimeout);
        this.inProgress = false;
        return;
      }

      // eğer korsan atama seçildiyse
      if (haveType === 4) {
        this.pirateDriverplanProp = order;
        this.$modal.show("pirate-driver-modal");
        clearTimeout(safetyTimeout);
        this.inProgress = false;
        return;
      }

      // Process the order selection through a dedicated service
      try {
        const processedOrder = await processOrderSelection(
          order,
          this.vehicleList,
          this.products,
          this.customers,
          this.selectedVehicles,
          haveType,
          this.$store,
          this.$swal
        );

        if (processedOrder && processedOrder.REALLOCATION_NEEDED) {
          // Uzak mesafedeki sipariş için araç çekme modalını göster
          this.reallocationMessage =
            processedOrder.message ||
            `${processedOrder.maxDistance} km mesafede uygun araç bulunamadı. Aktif siparişlerden araç çekilebilir.`;
          this.maxDistance = processedOrder.maxDistance || 300;

          // Aktif siparişleri ve araçları getir
          this.activeOrdersWithVehicles = processedOrder.vehicles;

          // Seçilen siparişi ve modalı ayarla
          this.selectedOrder = order;
          this.showReallocationModal = true;
          this.$modal.show("reallocation-needed-modal");
        } else if (processedOrder?.needCustomerAdd) {
          this.selectedOrder = order;
          this.$modal.show("add-customer-modal");
        } else if (processedOrder?.needProductAdd) {
          this.productName = order.productType;
          this.$modal.show("add-product-modal");
        } else {
          if (processedOrder) {
            this.selectedList.push({
              ...processedOrder,
              //Burada eğer başka bir araç önerisi yapılmışsa (Kırkayak gibi) onun typı öneri yapılırken seçilen type ile aynı olmayabilir onu güncelliyor.
              haveType:
                haveType != null
                  ? processedOrder?.haveType || haveType
                  : haveType,
            });
          }
        }
      } catch (error) {
        console.error("Error processing order selection:", error);
      } finally {
        clearTimeout(safetyTimeout);
        this.inProgress = false;
      }
    },

    handleReallocateVehicles({ orderNo, selectedVehicles }) {
      reallocateVehicles(
          orderNo, 
          selectedVehicles, 
          this.orderList, 
          this.selectedList,
          this.vehicleList,
          this.$swal, 
          this.$modal,
          (value) => (this.showReallocationModal = value), // showReallocationModal setleyen function parametresi
          this.$store.state.userData.token,
          this.customers,
          this.products
        );
    },

    removeFromPlanned(order) {
      // Onay modalını göstermek için hazırlık
      this.confirmationOrder = order;
      this.showConfirmationModal = true;
    },
    confirmRemoveOrder() {
      if (!this.confirmationOrder) return;

      const order = this.confirmationOrder;
      const index = this.selectedList.findIndex(
        (item) => parseInt(item.orderNo) === parseInt(order.orderNo)
      );

      if (index !== -1) {
        this.selectedList.splice(index, 1);
        if (order.tonnage < 30) {
          const vehicle = this.vehicleList.find(
            (v) => v.id === order.vehicle.id
          );
          vehicle.orderNos.pop();
        }
      }

      // Modal'ı kapat
      this.showConfirmationModal = false;
      this.confirmationOrder = null;
    },
    openContextMenu(event, item) {
      if (item.tonnage < 30 && this.activeState != 2) {
        this.selectedContextItem = item;
        this.$refs.menu.open(event);
      }
    },
    viewOrderDetail(order) {
      // selectedList'ten güncel veriyi al (distance güncellenmiş olabilir)
      const updatedOrder = this.selectedList.find(o => o.orderNo === order.orderNo);
      this.selectedOrder = updatedOrder || order;

      if ((updatedOrder || order).isPirateDriver == 1) {
        this.$modal.show("pirate-vehicle-detail-modal");
      } else {
        this.$modal.show("vehicle-modal");
      }
    },
    async handleChangeVehicle(val, item, isManualTyped = false){
        await changeVehicle(val, item, this.vehicleList, this.customers, this.products, this.$store.state.userData.token, isManualTyped);
    },
    clearOrders() {
      this.$swal.fire({
          title: "UYARI",
          text: "Planlanan siparişleri temizlemek istediğinize emin misiniz?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır"
        }).then((acc) => {
          if (acc.isConfirmed) this.selectedList = [];
        });
    },

    changeTab(tabIndex, resetPagination = true) {
      if (this.activeState != tabIndex) {
        // Reset search when changing tabs
        this.search = "";

        // Reset pagination if requested
        if (resetPagination) {
          this.currentPage = 0;
        }

        // Update active tab state
        this.activeState = tabIndex;

        // For the planned orders tab (tab 2)
        if (tabIndex === 2) {
          this.currentPage = 0;
          const itemsPerPage = 40;
          this.pageCount = Math.ceil(this.selectedList.length / itemsPerPage);
          if (this.pageCount === 0) {
            this.pageCount = 1;
          }
        } else {
          // For other tabs (1 - Planlanmayanlar or 3 - Sorunlular)
          // Load data but DON'T clear cache
          this.orderList = [];
        }
      } else {
        if (resetPagination) {
          this.currentPage = 1; // Start at page 1 instead of 0
        }
      }
    },

    changeDriver(driver, item) {
      item.driver = driver;
    },

    planWithEquipment() {
      // Yeni bir planlama başlatıyoruz, önceki işlemlerin inProgress state'ini temizle
      this.inProgress = false;

      this.selectedOrder = this.selectedContextItem;
      this.$modal.show('equipment-plan-modal');
    },

    async handleEquipmentPlan({ order, selectedCategories }) {
      if (this.inProgress) {
        return;
      }

      // Set inProgress IMMEDIATELY to prevent double calls
      this.inProgress = true;

      // Limit kontrolü
      const isValid = ordersRules.shouldNotExceedMaxOrderLimit(
        this.selectedList,
        this.$swal
      );
      if (!isValid) {
        this.inProgress = false;
        return;
      }

      try {
        // Zaten planlanmış mı kontrol et
        const isAlreadySelected = this.selectedList.find(
          (item) => parseInt(item.orderNo) === parseInt(order.orderNo)
        );

        if (isAlreadySelected) {
          this.removeFromPlanned(order);
          this.inProgress = false;
          return;
        }

        // Siparişe gerekli ekipman kategorilerini ekle
        const orderWithEquipmentRequirements = {
          ...order,
          requiredEquipmentCategories: selectedCategories // calculateEquipmentScore bu field'ı kullanacak
        };

        // Normal sipariş işleme akışını kullan - recommendation sistemi en uygun aracı bulacak
        const processedOrder = await processOrderSelection(
          orderWithEquipmentRequirements,
          this.vehicleList, // Tüm araç listesi
          this.products,
          this.customers,
          this.selectedVehicles,
          null, // haveType null - sistem kendisi belirleyecek
          this.$store,
          this.$swal
        );

        // Özel durumlar kontrolü
        if (!processedOrder) {
          this.inProgress = false;
          return;
        }

        if (processedOrder.needProductAdd) {
          this.$root.$emit("add-product-modal", processedOrder);
          this.inProgress = false;
          return;
        }

        if (processedOrder.needProductEdit) {
          this.defaultProductDataProp = processedOrder.defaultProductDataProp;
          this.$modal.show("product-edit-modal");
          this.inProgress = false;
          return;
        }

        if (processedOrder.needCustomerAdd) {
          this.selectedContextItem = processedOrder;
          this.$modal.show("add-customer-modal");
          this.inProgress = false;
          return;
        }

        if (processedOrder.isMultiple) {
          await this.$swal({
            title: "Uyarı",
            text: "Bu sipariş için birden fazla araç gereklidir. Lütfen sipariş detaylarını kontrol edin ve gerekli aracı manuel olarak atayın.",
            icon: "warning",
            confirmButtonText: "Tamam",
          });
          this.inProgress = false;
          return;
        }

        if (processedOrder.REALLOCATION_NEEDED) {
          this.reallocationData = processedOrder;
          this.$modal.show("reallocation-needed-modal");
          this.inProgress = false;
          return;
        }

        // Ekipman bilgisini ekle
        processedOrder.requiredEquipmentCategories = selectedCategories;
        processedOrder.isEquipmentBased = true; // Ekipman bazlı planlama bayrağı

        // Double-check: Emin olmak için son kez kontrol et
        const duplicateCheck = this.selectedList.find(
          (item) => parseInt(item.orderNo) === parseInt(processedOrder.orderNo)
        );

        if (duplicateCheck) {
          this.$toast.warning('Bu sipariş zaten planlanmış');
          return;
        }

        // Siparişi listeye ekle
        this.selectedList.push(processedOrder);

        const categoryLabels = selectedCategories.map(cat => {
          const labels = {
            'POMPA&HORTUM&DUSURUCU': 'Pompa & Hortum & Düşürücü',
            'GUVENLIK': 'Güvenlik Ekipmanı',
            'YEDEK_PARCA': 'Yedek Parça',
            'DIGER': 'Diğer'
          };
          return labels[cat] || cat;
        }).join(', ');

        this.$toast.success(`${categoryLabels} ekipmanına sahip ${processedOrder.vehicleName} ile planlandı`);

      } catch (error) {
        console.error('Error in equipment plan:', error);
        this.$toast.error(
          error?.response?.data?.message || 'Ekipman planlama sırasında hata oluştu'
        );
      } finally {
        this.inProgress = false;
      }
    },
    handlePageChange(newPage) {
      if (this.currentPage !== newPage) {
        this.currentPage = newPage;

        if (this.activeState !== 2) {
          this.orderList = [];
          this.getAll(true, true);
        }
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this._safetyTimeout);
    clearTimeout(this._searchDebounce);
  },
  async created() {
    try {
      // Initialize data
      this.vehicleList = await getLocationAll(this.$store.state.userData.token);

      // Ensure orderNos array is initialized for each vehicle
      this.vehicleList = this.vehicleList.map((vehicle) => ({
        ...vehicle,
        orderNos: vehicle.orderNos || [],
      }));

      this.customers = await getCustomers(this.$store.state.userData.token);
      this.products = await getProducts(this.$store.state.userData.token);

      await this.getAll();
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  },
  watch: {
    search() {
      // Debounce: hızlı yazımda her tuşa istek atmayı engeller
      clearTimeout(this._searchDebounce);
      this._searchDebounce = setTimeout(() => {
        this.$store.commit("orders/clearPage");
        this.getAll(true, true);
      }, 300);
    },
    activeState(val) {
      if (val !== 2) {
        this.orderList = [];
        this.getAll(true, false);
      }
    },
    currentPage(newVal, oldVal) {
      // Sadece gerçek sayfa değişiminde çalış (cascading watcher'dan gelen gereksiz tetiklemeleri engelle)
      if (newVal === oldVal) return;
      if (this.activeState === 2) return; // Planlanan tab'da API çağrısı gereksiz
      this.orderList = [];
      this.getAll(true, false);
    },
    selectedList: {
      handler(val) {
        if (val.length == 0 && this.activeState !== 1) this.activeState = 1;
        this.selectedVehicles = val.map((item) => ({
          plate: item.vehicleName,
        }));

        // Recalculate pagination if we're on the planned tab
        if (this.activeState === 2) {
          const itemsPerPage = 40;
          this.pageCount = Math.ceil(val.length / itemsPerPage);
          if (this.pageCount === 0) {
            this.pageCount = 1;
          }

          if (this.currentPage > this.pageCount) {
            this.currentPage = 1;
          }
        }
      },
      deep: false, // deep kaldırıldı — push/splice zaten Vue reactivity tarafından algılanıyor
    },
  },
};
</script>
<style>
@import "~vue-context/dist/css/vue-context.css";
</style>